// frontend/src/components/Shared/Toast.jsx
import React, { useRef, useCallback, useState } from 'react';

const COLORS = {
  success: 'bg-green-500',
  error:   'bg-red-500',
  info:    'bg-blue-500',
  warning: 'bg-yellow-500'
};

const ICONS = {
  success: (
    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    </svg>
  ),
  error: (
    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
  info: (
    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20A10 10 0 0012 2z" />
    </svg>
  ),
  warning: (
    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
    </svg>
  )
};

// Hook — call showToast(message, type) from any component
export const useToast = () => {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  const showToast = useCallback((message, type = 'success', duration = 3000) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast({ message, type });
    timerRef.current = setTimeout(() => setToast(null), duration);
  }, []);

  return { toast, showToast };
};

// Component — render this once at the root of the component that uses useToast
const Toast = ({ toast }) => {
  if (!toast) return null;

  const bg = COLORS[toast.type] || COLORS.success;
  const icon = ICONS[toast.type] || ICONS.success;

  return (
    <div
      className={`fixed top-4 right-4 z-50 flex items-center space-x-3 ${bg} text-white px-5 py-3 rounded-xl shadow-2xl text-sm font-medium`}
      style={{ animation: 'slideIn 0.2s ease-out' }}
    >
      <span>{icon}</span>
      <span>{toast.message}</span>
    </div>
  );
};

export default Toast;
